const baseURL = "/v1/GrupoOrigem";

const service = {
  methods: {
    $buscarGrupos(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarGrupo(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrarGrupo(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarGrupo(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarGrupo(id, body) {
      return this.$api().patch(`${baseURL}/${id}`, body);
    },
    $obterUsuariosGrupo(body) {
      const formData = new FormData();
      if (body) {
        Object.entries(body).forEach(([key, value]) => {
          if (value === null || value === undefined) return;
          if (Array.isArray(value)) {
            value.forEach((item) => formData.append(key, item));
          } else if (typeof value === 'object') {
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        });
      }
      return this.$api().post(`${baseURL}/ObterUsuarios`, formData);
    },
    $excluirGrupo(id, body) {
      return this.$api().delete(`${baseURL}/${id}`, body);
    },
  },
};

export default service;